/**
 * MODULE: QuickInsertFields
 * PURPOSE: Quick-access buttons for common template fields
 * DEPENDENCIES: flowbite-react, contactFieldsService
 * AGENT SAFETY: 🟢 SAFE
 */

import React from 'react';
import { Button } from 'flowbite-react';
import { ContactFieldsService, type ContactField } from '../../services/contactFieldsService';

interface QuickInsertFieldsProps {
  onFieldSelect: (field: ContactField) => void;
}

const QUICK_FIELDS = ContactFieldsService.getAllFields().filter((f) =>
  ['first_name', 'company_name', 'title', 'sender_name'].includes(f.id)
);

export default function QuickInsertFields({ onFieldSelect }: QuickInsertFieldsProps) {
  return (
    <div className="mb-3 flex flex-wrap items-center gap-2 rounded-lg bg-blue-50 p-2 dark:bg-blue-900/20">
      <span className="text-xs font-medium text-gray-600 dark:text-gray-400">
        Quick insert:
      </span>
      {QUICK_FIELDS.map((field) => (
        <Button
          key={field.id}
          size="xs"
          color="light"
          onClick={() => onFieldSelect(field)}
          className="font-mono"
          type="button"
        >
          {field.placeholder}
        </Button>
      ))}
    </div>
  );
}
